import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyA13pgw7TVs854up9A1Z5gxrDlxEJEENbM",
    authDomain: "padel-club-pk.firebaseapp.com",
    projectId: "padel-club-pk",
    storageBucket: "padel-club-pk.firebasestorage.app",
    messagingSenderId: "310575973777",
    appId: "1:310575973777:web:6694887e678c1bdf6f4630"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);// Initialize Firebase Cloud Messaging and get a reference to the service

export const messaging = getMessaging(app);

export const generateToken = async () => {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
        const token = await getToken(messaging, {
            vapidKey: "BGAMMYay9I8-oUYNJaTKg24ol7gbgXc-9akXc8MIp7KzMF3a8UFOkNgDnvqFJyLPAATEeOHwwWIOYeDOhdsXHqQ",
        })
        return token;
    }
    else {
        console.log("Permission not granted for notifications");
        return "";
    }}